import { type FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useToken } from "@packsize/authentication";

import { InfoRow } from "./info-row";

export const UserInformationCard: FC = () => {
	const intl = useIntl();
	const { decodedToken } = useToken();

	if (decodedToken === null) {
		return null;
	}

	return (
		<Card id="developer-user-details">
			<CardContent>
				<Typography variant="h3" component="h2" gutterBottom>
					<FormattedMessage id="User Details" defaultMessage="User Details" />
				</Typography>
				<Stack spacing={2}>
					<InfoRow
						label={intl.formatMessage({ id: "Current User Id", defaultMessage: "Current User Id" })}
						value={decodedToken.id}
					/>
					<InfoRow
						label={intl.formatMessage({ id: "Current User", defaultMessage: "Current User" })}
						value={decodedToken.sub}
					/>
					<InfoRow
						label={intl.formatMessage({ id: "Company", defaultMessage: "Company" })}
						value={decodedToken.Company}
					/>
					<InfoRow
						label={intl.formatMessage({ id: "Site ID", defaultMessage: "Site ID" })}
						value={decodedToken.SiteId}
					/>
					<InfoRow
						label={intl.formatMessage({ id: "Customer ID", defaultMessage: "Customer ID" })}
						value={decodedToken.CustomerId}
					/>
					<InfoRow
						label={intl.formatMessage({ id: "Tenant ID", defaultMessage: "Tenant ID" })}
						value={decodedToken.Tenant}
					/>
				</Stack>
			</CardContent>
		</Card>
	);
};
